import { Card, CardContent, CardHeader, CardTitle } from '@talentmesh/ui/components/card';
import { Navigate } from 'react-router';
import useSetupAccountPageState from './Hook/useSetupAccountPageState';
import AccountCreationForm from '@/Components/AccountCreation/AccountCreationForm';
import MeshBackgroundCenterOverlay from '@/Components/layouts/MeshBackroundCenterOverlay';
import { CompanyLogo, LoadingOverlay } from '@/Components/shared';
import { useUserContext } from '@/Context/UserContext';
import RoutePath from '@/Routing/RoutePath';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';
import UIStrings from '@/Utils/UIStrings';

const SetupAccountPage = () => {
    const { allowAccountSetup, isLoading, isSubmitting, submitHandler } = useSetupAccountPageState();
    const { user } = useUserContext();

    if (isLoading) {
        return <LoadingOverlay />;
    }

    return allowAccountSetup ? (
        <MeshBackgroundCenterOverlay>
            <CompanyLogo
                width={195}
                height={37.5}
                color="primary"
                className="mb-8 shrink-0"
                aria-label={UIStrings.CompanyLogo}
            />
            <Card className="border-border w-full overflow-hidden rounded-2xl border drop-shadow-xl">
                <CardHeader className="px-6 py-6">
                    <CardTitle className="text-foreground text-xl font-semibold tracking-tight md:text-2xl">
                        {UIStrings.SetupYourProfile}
                    </CardTitle>
                </CardHeader>
                <CardContent className="px-6">
                    <AccountCreationForm
                        submitHandler={submitHandler}
                        isSubmitting={isSubmitting}
                        initialCompanyName=""
                        initialFirstName={user.firstName || ''}
                        initialLastName={user.lastName || ''}
                    />
                </CardContent>
            </Card>
        </MeshBackgroundCenterOverlay>
    ) : (
        <Navigate to={RoutePath.Root} />
    );
};

export default withTalentMeshUserRequired(SetupAccountPage);
